import { z } from 'my-zod'

// Used for cases and polarisUsers
export const TeamsEnum = z
  .enum([
    'AccountManagers',
    'ASRs',
    'Fleet',
    'Risk',
    'Quality',
    'ServiceAndOperationsSupport',
    'Select',
    'Marketing',
    'Finance',
    'Leadership'
  ])
  .setEnumLabels({
    AccountManagers: 'Account Managers',
    ASRs: 'ASRs',
    Fleet: 'Fleet',
    Risk: 'Risk',
    Quality: 'Quality',
    ServiceAndOperationsSupport: 'Service & Operations Support',
    Select: 'Select',
    Marketing: 'Marketing',
    Finance: 'Finance',
    Leadership: 'Leadership'
  })

export type TeamsEnum = z.infer<typeof TeamsEnum>
